





























































import AppCheckbox from "@/components/AppCheckbox.vue";
import { emptyFn } from "@/fp";
import {
  computed,
  onBeforeUnmount,
  onMounted,
  ref,
  watch,
} from "@vue/composition-api";
import Vue from "vue";
export default Vue.extend({
  components: { AppCheckbox },
  props: ["value"],
  setup(_, { emit }) {
    const MINIMUM_SCAN_SIZE = 100;
    const DEFAULT_MAX_SCAN_SIZE = 10_000_000;

    const is_sampling = ref(false);
    const is_specific_location = ref(true);
    const specific_location_path = ref("");
    const max_size = ref(100);

    const is_valid_form = computed(() => {
      if (is_specific_location.value) {
        return specific_location_path.value.length > 0;
      }
      return true;
    });

    const get_values = () => {
      const params: Record<string, string | number> = {
        scanPaths: is_specific_location.value
          ? JSON.stringify([specific_location_path.value])
          : "[]",
      };

      if (is_sampling.value) {
        params.isFullScan = "false";
        params.scanSizeLimit = max_size.value;
      } else {
        params.isFullScan = "true";
      }

      return {
        is_valid: is_valid_form.value,
        params,
      };
    };

    const subs = {
      validation: emptyFn(),
    };

    onMounted(() => {
      subs.validation = watch(
        [
          is_valid_form,
          is_sampling,
          is_specific_location,
          specific_location_path,
          max_size,
        ],
        () => {
          const vals = get_values();
          console.log("vals::", vals);
          emit("input", vals);
        },
        {
          lazy: false,
        }
      );
    });

    onBeforeUnmount(() => Object.values(subs).forEach((unsub) => unsub()));

    return {
      is_sampling,
      is_specific_location,
      max_size,
      specific_location_path,
      get_values,
      MINIMUM_SCAN_SIZE,
      DEFAULT_MAX_SCAN_SIZE,
    };
  },
});
